import * as devisConf from '@/configuration/devisConf';

export default function miseAJourArticle(ligneCommande) {
  ligneCommande.typeRemise = devisConf.POURCENTAGE;
  ligneCommande.remise = 0;
  ligneCommande.tauxTva = 20;
  ligneCommande.uniteVente = devisConf.UNITE;
  ligneCommande.type = devisConf.NORMAL;
  ligneCommande.prixUnitaire = 0;
  ligneCommande.quantite = 1;
}
